import { JOBS_SITE_URL, PEOPLY_SITE_URL } from '@/constants/jobsSite';
import { LOGIN_ACCOUNT_TYPES } from '@/constants/login';
import { SIGNUP_PATH } from '@/constants/signup';
import { safeNextPath } from '@/careers/lib/redirect';
import { isCandidateAreaOrigin, isJobsSiteOrigin } from '@/lib/jobsSite';
import type { LoginAccountType } from '@/types/accountType';

/**
 * The tab the sign-in / sign-up page opens on. With the listings on their own domain each domain
 * has one: candidates there, companies on Peoply. Otherwise coming from the candidate area
 * (?next=/careers/...) means the candidate tab; everything else — the HR app's own links and
 * bookmarks — the employer tab.
 */
export const initialAccountType = (search: string): LoginAccountType => {
  if (JOBS_SITE_URL) return isJobsSiteOrigin() ? LOGIN_ACCOUNT_TYPES.candidate : LOGIN_ACCOUNT_TYPES.employer;
  return safeNextPath(search) ? LOGIN_ACCOUNT_TYPES.candidate : LOGIN_ACCOUNT_TYPES.employer;
};

/**
 * Whether the sign-in / sign-up page offers the candidate / employer tabs: only while both live on
 * one site. With the listings on their own domain each page has one account type — candidates
 * there, companies on Peoply — and Peoply never sends anyone to the listings' domain.
 */
export const showsAccountTypeTabs = (): boolean => !JOBS_SITE_URL;

/** Whether candidates can open an account from here: not on Peoply's site once the listings have their own domain. */
export const offersCandidateSignup = (): boolean => isCandidateAreaOrigin();

/** The company sign-up page: on Peoply, also when linked from the listings' own domain. */
export const companySignupUrl = (): string => (isJobsSiteOrigin() ? `${PEOPLY_SITE_URL}${SIGNUP_PATH}` : SIGNUP_PATH);
